export const FONT_WEIGHT = {
  BOLD: 'bold',
  SEMI: 600,
  NORMAL: 'normal'
};

const textStyles = {
  // Headings Font Sizes
  heading1: {
    fontSize: {
      base: '1.8rem',
      xl: '2.5rem',
      '2xl': '3rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading2: {
    fontSize: {
      base: '1.05rem',
      xl: '1.625rem',
      '2xl': '1.75rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading3: {
    fontSize: {
      base: '1.025rem',
      xl: '1.5rem',
      '2xl': '1.625rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading4: {
    fontSize: {
      base: '1rem',
      xl: '1.25rem',
      '2xl': '1.375rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading5: {
    fontSize: {
      base: '1rem',
      xl: '1.125rem',
      '2xl': '1.25rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading6: {
    fontSize: {
      base: '0.875rem',
      xl: '0.94rem',
      '2xl': '1.06rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  },
  heading7: {
    fontSize: {
      base: '0.75rem',
      xl: '0.813rem',
      '2xl': '0.938rem'
    },
    fontWeight: FONT_WEIGHT.SEMI,
    lineHeight: '6rem'
  }
};

export type TextStyles = typeof textStyles;

export default textStyles;

// display1: {
//   fontSize: '4.8rem',
//   fontWeight: FONT_WEIGHT.SEMI,
//   lineHeight: '6rem',
// },
// display2: {
//   fontSize: '4rem',
//   fontWeight: FONT_WEIGHT.SEMI,
//   lineHeight: '4.8rem',
// },
// h1Semi: {
//   fontSize: '3.2rem',
//   fontWeight: FONT_WEIGHT.SEMI,
//   lineHeight: '4.0rem',
// },
// body1Semi: {
//   fontSize: '2rem',
//   fontWeight: FONT_WEIGHT.SEMI,
//   lineHeight: '2.8rem',
// },
// body1: {
//   fontSize: '2rem',
//   fontWeight: FONT_WEIGHT.NORMAL,
//   lineHeight: '2.8rem',
// },
// body2: {
//   fontSize: '1.6rem',
//   fontWeight: FONT_WEIGHT.NORMAL,
//   lineHeight: '2.4rem',
// },
// body2Semi: {
//   fontSize: '1.6rem',
//   fontWeight: FONT_WEIGHT.SEMI,
//   lineHeight: '2.4rem',
// },
